"use strict";
(self["webpackChunklilacst"] = self["webpackChunklilacst"] || []).push([[3047],{

/***/ 3047:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ bind)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);


function bind({ wrapper }) {
  const bindData = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('bind').split(',')

  ;(function init() {
    if (!bindData.length) return

    bindData.forEach((data, index) => {
      const splitData = data.split(':')
      const [targetSelector, property] = splitData
      const $target = jquery__WEBPACK_IMPORTED_MODULE_0___default()(targetSelector)

      if (!targetSelector || !$target.length || !property) return

      // TODO: Listen for changes
      // Mutation Observer?

      let boundVar = null
      if (property == 'height') {
        boundVar = $target[0].offsetHeight + 'px'
      }

      const cssVar = `--bind-${index + 1}`

      // console.log(`Binding "${cssVar}: ${boundVar}" to element:`, wrapper)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).css(cssVar, boundVar)
    })
  })()
}


/***/ })

}]);